<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg12>
          <p class="table_card__head--title">
            Importador de usuarios
          </p>
          <v-breadcrumbs class="breadcums">
            <v-breadcrumbs-item
              disabled
              class="breadcums__disable"
            >
              Importador
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body">
      <section v-if="charge" class="trainers__create_container">
        <v-layout row wrap>
          <v-flex xs8>
            <div :style="excelTitle.length<=0?'':''">
              <!-- Fotos de la oferta -->
              <span class="table_card__info--label">Adjuntar información (Formato Excel)</span>
              <div class="trainers__form--photo_container" style="width:max-content">
                <label
                  for="excel_input"
                  class="faccess_button buttom_shadow px-5">Examinar</label>
                <input
                  id="excel_input"
                  type="file"
                  @change="excelUpload()"
                  name="logo"
                  multiple>
                  <p class="accessIndex__text--small" style="margin-left:10%" v-if="excelTitle.length<=0" >Debe adjuntar un archivo con formato Excel</p>
                </div>
              </div>
            <v-flex>
                <div v-if="excelTitle.length!=0">
                  <p class="data_card__info--label">Nombre del archivo </p>
                  <p style="font-size: 10px;" ><img style="width:26px" src="https://karrottsportlife.s3-us-west-2.amazonaws.com/excel.png"/>{{excelTitle}}</p>
                </div>
            </v-flex>

          </v-flex>

          <v-flex xs4 v-if="excelTitle.length!=0" >
              <section class="data_card data_card__instance">
              </section>
              <button style="float: right;"
                class="faccess_button"
                @click="uploadInfo()">
                Cargar Datos
              </button>
          </v-flex>
          <v-flex  xs12>
            <div v-if="tableData.length>0" style="margin-top: 30px;">
              <v-data-table
                :headers="headers"
                :items="tableData"
                class="elevation-1"
                hide-actions>
                <template slot="items" slot-scope="props">
                  <tr  class="importers__user_row">
                    <td v-for="data in Object.entries(props.item)" class="importers__user_data">
                      <input
                        :value="getCellValue(props.item, data[0])"
                        :placeholder="data[0]"
                        :class="{ 'importers__input_data--invalid': !isFieldValid(data[0], getCellValue(props.item, data[0])) }"
                        :title="!isFieldValid(data[0], getCellValue(props.item, data[0])) ? getFieldError(data[0]) : ''"
                        :aria-invalid="!isFieldValid(data[0], getCellValue(props.item, data[0]))"
                        class="importers__input_data"
                        @input="updateCell(props.item, data[0], $event.target.value)">
                      <span
                        v-if="data[0] === 'Email' && !isFieldValid(data[0], getCellValue(props.item, data[0]))"
                        class="importers__field_error">
                        Formato de email no válido
                      </span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-flex>
        </v-layout>

        <br>

        <v-layout row wrap>
          <v-flex xs8>
            <div :style="zipTitle.length<=0?'':''">
              <!-- Fotos de la oferta -->
              <span class="table_card__info--label">Adjuntar fotos en Zip (Formato JPG)</span>
              <div class="trainers__form--photo_container" style="width:max-content">
                <label
                  for="zip_input"
                  class="faccess_button buttom_shadow px-5">Examinar</label>
                <input
                  id="zip_input"
                  type="file"
                  @change="zipUpload()"
                  name="logo"
                  multiple>
                  <p class="accessIndex__text--small" style="margin-left:10%" v-if="zipTitle.length<=0" >Debe adjuntar un archivo con formato Zip</p>
                </div>
              </div>
            <v-flex>
                <div v-if="zipTitle.length!=0">
                  <p class="data_card__info--label">Nombre del archivo </p>
                  <p style="font-size: 10px;" ><img style="width:26px" src="https://www.freeiconspng.com/uploads/file-zip-icon-9.png"/>{{zipTitle}}</p>
                </div>
            </v-flex>
          </v-flex>

          <v-flex xs4 v-if="zipTitle.length!=0" >
              <section class="data_card data_card__instance">
              </section>
              <button style="float: right;"
                class="faccess_button"
                @click="uploadPhotos()">
                Cargar Fotos
              </button>
          </v-flex>

        </v-layout>

      </section>
    </div>
  </div>
</template>
<script>
import JSZip from "jszip";
export default {
  data() {
    return {
      charge: true,
      tableData: [],
      access: [],
      excelTitle:"",
      zipTitle:"",
      isHidden:false,
      renderComponents:true,
      files:[],
      requiredFields: ['Rut', 'Tipo de documento', 'Email', 'Nombre', 'Apellido', 'Plan de usuario'],
      numericFields: ['Celular'],
      textFields: ['Tipo de documento', 'Nombre', 'Apellido', 'Pais indicativo', 'Genero', 'Categoria', 'Nacionalidad', 'Plan de usuario', 'Departamento'],
      dateFields: ['Fecha de nacimiento', 'Fecha inicio', 'Fecha fin'],
    }
  },
  computed: {
    headers() {
      const baseHeaders = [
        { text: 'Rut *', align: 'left', sortable: false, value: 'Rut' },
        { text: 'Tipo de documento *', align: 'left', sortable: false, value: 'Tipo de documento' },
        { text: 'Email *', align: 'left', sortable: false, value: 'Email' },
        { text: 'Nombre *', align: 'left', sortable: false, value: 'Nombre' },
        { text: 'Apellido *', align: 'left', sortable: false, value: 'Apellido' },
        { text: 'Pais indicativo', align: 'left', sortable: false, value: 'Pais indicativo' },
        { text: 'Celular', align: 'left', sortable: false, value: 'Celular' },
        { text: 'Genero', align: 'left', sortable: false, value: 'Genero' },
        { text: 'Fecha de nacimiento', align: 'left', sortable: false, value: 'Fecha de nacimiento' },
        { text: 'Categoría', align: 'left', sortable: false, value: 'Categoria' },
        { text: 'Fecha inicio', align: 'left', sortable: false, value: 'Fecha inicio' },
        { text: 'Fecha fin', align: 'left', sortable: false, value: 'Fecha fin' },
        { text: 'Nacionalidad', align: 'left', sortable: false, value: 'Nacionalidad' },
        { text: 'Plan de usuario *', align: 'left', sortable: false, value: 'Plan de usuario' },
      ];
      if (this.getCompany().access_invitation_approved) {
        baseHeaders.push({ text: 'Departamento', align: 'left', sortable: false, value: 'Departamento' });
      }

      return baseHeaders;
    },
  },
  methods:{

    zipUpload(){

      let vm = this
      const fileSelector = document.getElementById('zip_input');
      vm.zipTitle=fileSelector.files[0].name;

      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.zip)$/;
      if (regex.test(fileSelector.value.toLowerCase())) {

        console.log('zipUpload')

        const fileSelector = document.getElementById('zip_input');
        let file = fileSelector.files[0];
        // let fileReader = new FileReader();
        console.log('fileSelector', fileSelector)
        // let file = e.dataTransfer.files[0];
        JSZip.loadAsync(file).then( (zip) => {
          Object.keys(zip.files).forEach( (filename) => {
            // this.filesList.push(filename);
            console.log(zip.file(filename));
            zip.file(filename).async('blob').then( (blob) => {

              var photoName = filename.split('.')

              // if(blob.size > 200000){
              //   vm.zipTitle = ""
              //   alert("Existe una o mas fotos que superan el límite de tamaño permitido (Max 200KB)");
              //
              // } else if(photoName[1] != "jpg" && photoName[1] != "jpeg" ){
              //   vm.zipTitle = ""
              //   alert("Existe una o mas fotos que no tienen el formato permitido (JPG O JPEG)");
              //
              // } else {
              //
              //   var reader = new FileReader();
              //   reader.readAsDataURL(blob);
              //   reader.onloadend = function(){
              //     var base64data = reader.result;
              //     vm.files.push({ name: photoName[0], base64data: base64data })
              //   }
              // }

              if(photoName[1] != "jpg" && photoName[1] != "jpeg" ){
                vm.zipTitle = ""
                alert("Existe una o mas fotos que no tienen el formato permitido (JPG O JPEG)");
              } else {
                this.compressImage(blob, parseInt(10))
                .then(compressedImage => {

                  let reader = new FileReader();
                  reader.readAsDataURL(compressedImage);
                  reader.onload = () => {
                    vm.files.push({name: photoName[0],base64data: reader.result});
                  }
                })
              }

            });

          });
        });

        console.log('this files', vm.files)


      }else{
        vm.zipTitle = ""
        alert("Por favor subir un archivo de códigos válido (Formato Zip).");
      }

    },

    compressImage(imageFile, quality){
      return new Promise((resolve, reject) => {
        const $canvas = document.createElement("canvas")
        const imagen = new Image();
        var oldWidth , oldHeight , newHeight , newWidth = 1000;
        imagen.onload = () => {
          oldWidth = imagen.width;
          oldHeight = imagen.height;
          if (oldHeight > 1200){
            newHeight = 1000
            newWidth = Math.floor(newHeight/(oldHeight / oldWidth))
          }else{
            newHeight = Math.floor(oldHeight / oldWidth * newWidth)
          }
          console.log("<<<<<<<<<<<<<<<<<<<Size");
          console.log('H = '+newHeight);
          console.log('W = '+newWidth);
          $canvas.width = newWidth;
          $canvas.height = newHeight;
          $canvas.getContext("2d").drawImage(imagen, 0, 0, newWidth,newHeight);
          $canvas.toBlob(
            (blob) => {
              if (blob === null) {
                return reject(blob);
              } else {
                resolve(blob);
              }
            },
            "image/jpeg",
            quality / 100
          );
        };
        imagen.src = URL.createObjectURL(imageFile);
      });
    },

    uploadPhotos(){

      let finalJson={photos: this.files, company_id: this.getCompany().id}
      try
      {
        this.$http.post('app/users/import_photos',{
          data: this.encrypt(finalJson).toString(),
          attributes:this.encrypt(finalJson).toString()
        },
        {
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }

        }).then(function(response){
          // this.charge = false;
          // this.$router.push({name: 'import_users'});
          this.files = []
          this.zipTitle = ""
          setTimeout(()=> { this.charge = true; },1000)
          this.updateAlertMessage(response.body.ans);
          this.updateIsInAlert(true);

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log('response */*/*/*/**/', response.body.ans)
          this.updateAlertMessage(response.body.ans);
          this.updateIsInAlert(true);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta0authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      }
      catch (e)
      {
        alert(e.message)
      }


    },

    excelUpload(){
      var fileUpload = document.getElementById("excel_input");
      //Validate whether File is valid Excel file.
      var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.xls|.xlsx|.ods|.xlsm|.xsv|.txt)$/;
      if(fileUpload.files.length > 0){
        if (regex.test(fileUpload.value.toLowerCase())) {
          this.tableData = []
          var vm=this;
          if (typeof (FileReader) != "undefined") {
            var reader = new FileReader();
            vm.excelTitle=fileUpload.files[0].name;
            //For Browsers other than IE.
            if (reader.readAsBinaryString) {
              reader.onload = function (e) {
                  vm.usersJson={};
                  vm.ProcessExcel(e.target.result);
              };
              reader.readAsBinaryString(fileUpload.files[0]);
            } else {
              //For IE Browser.
              reader.onload = function (e) {
                  var data = "";
                  var bytes = new Uint8Array(e.target.result);
                  for (var i = 0; i < bytes.byteLength; i++) {
                      data += String.fromCharCode(bytes[i]);
                  }
                  vm.ProcessExcel(data);
              };
              reader.readAsArrayBuffer(fileUpload.files[0]);
            }
          } else {
            alert("Este navegador no soporta HTML5");
          }
        } else {
          alert("Por favor subir un archivo de códigos válido (Formato Excel)");
        }
      }
    },
    ProcessExcel(data){
      //Read the Excel File data.
      var workbook = XLSX.read(data, {
        type: 'binary'
      });

      //Fetch the name of First Sheet.
      var firstSheet = workbook.SheetNames[0];

      //Read all rows from First Sheet into an JSON array.
      var excelRows = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[firstSheet]);
      var excelRowsJson = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheet], {raw: true});
      this.XLSX = excelRowsJson;
      // var header = Object.keys(excelRowsJson[0]);

      //Add the data rows from Excel file.
      for (var i = 0; i < excelRows.length; i++) {
        //Add the data row.
        var array = {};

        this.headers.forEach(header => {
          const excelValue = this.getExcelFieldValue(excelRowsJson[i], header.value)
          array[header.value] = [this.normalizeField(excelValue, header.value)]
        })

        // for (var a = 0; a < this.headers.length; a++) {
        //   // if(array[header[a]] = [excelRowsJson[i][header[a]]];)
        //   // console.log('=====', excelRowsJson[i][header[a]].trim() )
        //     // array[header[a]] = [excelRowsJson[i][header[a]].trim()];
        //     array[] = [excelRowsJson[i][header[a]]] ? [excelRowsJson[i][header[a]]] : ''
        //     // console.log(header[a], excelRowsJson[i]['Indicativo de celular'])
        // }
        this.tableData.push(array);
        console.log('this.tableData',this.tableData);
        //Add the data cells.
      }
    },
    uploadInfo(){
      let finalJson={new: this.tableData, company_id: this.getCompany().id}
      try
      {
        this.tableData.forEach((i, index) => {
          Object.keys(i).forEach(field => {
            const value = this.getCellValue(i, field)
            i[field] = [this.normalizeField(value, field)]
            if (!this.isFieldValid(field, i[field][0])) {
              throw { message: this.getFieldError(field), fila: index + 1 }
            }
          })

          if(this.getCompany().access_invitation_approved && !this.getCellValue(i, 'Departamento')){
            throw { message: "El Departamento ingresado no es válido", fila: index + 1 }
          }
        })

        this.$http.post('app/users/upload_user_or_create',{
          data: this.encrypt(finalJson).toString(),
          attributes:this.encrypt(finalJson).toString()
        },
        {
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }

        }).then(function(response){
          this.charge = false;
          this.$router.push({name: 'import_users'});
          this.tableData = []
          this.excelTitle = ""
          setTimeout(()=> { this.charge = true; },1000)
          this.updateAlertMessage(response.body.ans);
          this.updateIsInAlert(true);

          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.errors[0].title.includes("invalid input syntax for type date:")){
            this.updateAlertMessage("Las fechas ingresadas en el archivo no tienen el formato correcto");
            this.updateIsInAlert(true);
          }
          this.updateAlertMessage(response.body.ans || response.body.errors[0].details);
          this.updateIsInAlert(true);
          if(response.body.errors[0].status == 500) {
            this.updateAlertMessage("Error de conexión. Verifica la conexión a internet o la energía del dispositivo.");
            this.updateIsInAlert(true);
          }
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta0authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      }
      catch (e){
        console.log(e)
        this.updateAlertMessage(`${e.message}${e.fila ? ` en la fila ${e.fila}` : ''}`);
        this.updateIsInAlert(true);
      }
    },
    getCellValue(row, field) {
      const value = row[field]
      return Array.isArray(value) ? value[0] || '' : value || ''
    },
    updateCell(row, field, value) {
      this.$set(row, field, [this.normalizeField(value, field)])
    },
    getExcelFieldValue(row, field) {
      if (Object.prototype.hasOwnProperty.call(row, field)) return row[field]

      const expectedField = String(field).trim().toLowerCase()
      const matchingKey = Object.keys(row).find(key => {
        return String(key).replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase() === expectedField
      })

      return matchingKey === undefined ? '' : row[matchingKey]
    },
    normalizeField(value, field) {
      let normalized = value === undefined || value === null ? '' : String(value)
      normalized = normalized.replace(/[\r\n]+/g, ' ').replace(/\s+/g, ' ').trim()
      return normalized
    },
    isFieldValid(field, value) {
      const normalized = this.normalizeField(value, field)
      if (!normalized && this.requiredFields.includes(field)) return false
      if (!normalized) return true

      if (this.numericFields.includes(field)) return /^\d+$/.test(normalized)
      if (this.textFields.includes(field)) return /^[A-Za-zÁÉÍÓÚáéíóúÑñÜüÇç\s'-]+$/.test(normalized)
      if (field === 'Email') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized)
      if (field === 'Rut') return /^[0-9]+(?:[-.]?[0-9kK])?$/.test(normalized)
      if (this.dateFields.includes(field)) return /^[0-9/.-]+$/.test(normalized)
      return true
    },
    getFieldError(field) {
      if (this.numericFields.includes(field)) return `El campo ${field} solo debe contener números`
      if (field === 'Email') return 'El email ingresado no es válido'
      if (this.textFields.includes(field)) return `El campo ${field} solo debe contener letras`
      if (field === 'Rut') return 'El Rut ingresado no es válido'
      if (this.dateFields.includes(field)) return `La fecha de ${field} no es válida`
      return `El campo ${field} no es válido`
    }
  }
}

</script>

<style lang="css" scoped>
p{
  margin-bottom: 0;
}

.text_title{
  font-weight: bold;
  margin-bottom: 10px;
}

.importers__input_data--invalid {
  border: 1px solid #d32f2f;
}

.importers__field_error {
  color: #d32f2f;
  display: block;
  font-size: 11px;
  margin-top: 3px;
}

/* .v-table__overflow {
    width: 100%;
    overflow-x: auto;
    overflow-y: auto !important;
    height: 320px !important;
} */

</style>



// WEBPACK FOOTER //
// src/components/views/import_users/ImportUser.vue